import { ProActions, ProPlanState, EstimatedPriceState, AaChangeRequestState } from './pro.types';

const initialState = {
  plan: { status: 'idle', data: null, error: '' } as ProPlanState,
  aaChangeRequest: { status: 'idle', data: null, error: '' } as AaChangeRequestState,
  rcpId: null as number | null,
  postProSubscriptionState: { status: 'idle', error: '' } as BaseState,
  estimatedPriceState: {
    status: 'idle',
    data: { shardTypePricingList: [], price: 0 },
    error: ''
  } as EstimatedPriceState
};

// eslint-disable-next-line @typescript-eslint/default-param-last
const proReducer = (state = initialState, action: ProActions): typeof initialState => {
  switch (action.type) {
    case 'POST_PRO_PLAN_REQUEST':
      return {
        ...state,
        plan: {
          ...state.plan,
          error: '',
          status: 'pending'
        }
      };

    case 'POST_PRO_PLAN_SUCCESS':
      return {
        ...state,
        plan: {
          ...state.plan,
          status: 'resolved',
          data: action.payload.proPlan
        },
        rcpId: action.payload.rcpId
      };

    case 'POST_PRO_PLAN_FAILURE':
      return {
        ...state,
        plan: {
          ...state.plan,
          data: null,
          status: 'rejected'
        },
        rcpId: null
      };

    case 'POST_PRO_SUBSCRIPTION_REQUEST':
    case 'EXECUTE_AA_SUBSCRIPTION_REQUEST':
    case 'CREATE_AA_SUBSCRIPTION_REQUEST':
      return {
        ...state,
        postProSubscriptionState: {
          error: '',
          status: 'pending'
        }
      };

    case 'POST_PRO_SUBSCRIPTION_SUCCESS':
    case 'CREATE_AA_SUBSCRIPTION_SUCCESS':
      return initialState;

    case 'CREATE_ONLY_AA_SUBSCRIPTION_REQUEST':
      return {
        ...state,
        aaChangeRequest: {
          error: '',
          status: 'pending',
          data: null
        }
      };

    case 'CREATE_ONLY_AA_SUBSCRIPTION_SUCCESS':
      return {
        ...state,
        aaChangeRequest: {
          error: '',
          status: 'resolved',
          data: action.payload.aaChangeRequestPayload
        }
      };

    case 'POST_PRO_SUBSCRIPTION_FAILURE':
    case 'CREATE_AA_SUBSCRIPTION_FAILURE':
      return {
        ...state,
        postProSubscriptionState: {
          error: '',
          status: 'rejected'
        }
      };

    case 'CALCULATE_PRICE_REQUEST':
      return {
        ...state,
        estimatedPriceState: {
          ...state.estimatedPriceState,
          status: 'pending',
          error: ''
        }
      };

    case 'CALCULATE_PRICE_SUCCESS': {
      const { price, shardTypePricingList = [], comparedPrice, comparedSize } = action.payload;

      return {
        ...state,
        estimatedPriceState: {
          status: 'resolved',
          error: '',
          data: { price, shardTypePricingList, comparedPrice, comparedSize }
        }
      };
    }
    case 'CALCULATE_PRICE_FAILURE':
      return {
        ...state,
        estimatedPriceState: {
          data: initialState.estimatedPriceState.data,
          status: 'rejected',
          error: action.payload
        }
      };

    case 'RESET_PRO_STATE':
      return initialState;

    case 'CLEAR_PRO_PLAN':
      return {
        ...state,
        plan: initialState.plan,
        rcpId: null
      };
    default:
      return state;
  }
};

export default proReducer;
